/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'bi/glass/common/ui/SubmitPasswordDialog',
	'../../nls/StringResources'
], ($, SubmitPasswordDialog, StringResources) => {

	const ADMIN_ACCOUNT_URL = 'v1/users_ex/';
	const CREDENTIALS_URL = 'v1/users/~/credentials';

	class CredentialDialogs {

		constructor(Glass) {
			this.Glass = Glass;
		}

		openRenewCredentialDialog(displayObjects) {
			return this._openCredentialDialog(displayObjects, StringResources.get('credentialChange'), 'renewCredential');
		}

		openCreateCredentialDialog(displayObjects) {
			return this._openCredentialDialog(displayObjects, StringResources.get('credentialCreate'), 'createCredential');
		}

		_openCredentialDialog(displayObjects, title, defaultId) {
			return new Promise((resolve, reject) => {
				const displayPrompts = this._buildParameters(displayObjects);
				const dialogOptions = {
					buttons: [{
						text: StringResources.get('ok'),
						handler: this._submitCredential.bind(this, resolve, reject),
						type: 'primary',
						defaultId
					}, 'cancel'],
					title: title,
					viewOptions: {
						glassContext: this.Glass,
						displayPrompts: displayPrompts
					},
					cancelCallback: () => {
						this._credentialDialogObj.dialog.hide();
						reject();
					}
				};

				SubmitPasswordDialog.prototype.openSubmitPasswordDialog(dialogOptions).then((credentialDialogObj) => {
					this._credentialDialogObj = credentialDialogObj;
				}, reject);
			});
		}

		_submitCredential(resolve, reject) {
			$.each(this.credentialParameters, (key, prompt) => {
				const displayObject = $(`input[class*="${prompt.name}"]`);
				if (displayObject.length) {
					const value = displayObject.val();
					if (value) {
						prompt.value = value;
					}
				}
			});

			const options = {
				type: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				url: CREDENTIALS_URL,
				data: JSON.stringify({
					parameters: this.credentialParameters
				}),
				skipErrorHandling: true
			};

			// WARNING - old ajax service exposes jquery ajax api;  this is different than '.getCoreSvc('.Ajax');
			/// we should update this line to use new service in the future...
			this.Glass.services.ajax.ajax(options).then(() => {
				this._credentialDialogObj.dialog.hide();
				this.Glass.showToast(StringResources.get('credentialCreateSuccess'));
				resolve();
			}, (dfd, jqXHR, textStatus, errorThrown) => {
				if (jqXHR.status === this.Glass.ajaxCodes.UNAUTHORIZED && jqXHR.responseJSON && jqXHR.responseJSON.errorCodeString === 'camAuthUserRecoverable') {
					// Request failed with incorrect password.
					this.Glass.showToast(StringResources.get('wrongPassword'), { type: 'error' });
					// Rebuild the parameters so the password already read is refreshed.
					this._buildParameters(jqXHR.responseJSON.promptInfo.displayObjects);
				} else {
					reject();
					this.Glass.showToast(errorThrown, { type: 'error' });
					this._credentialDialogObj.dialog.hide();
				}
			});
		}

		openResetPasswordDialog() {
			return new Promise((resolve, reject) => {
				const dialogOptions = {
					buttons: [{
						text: StringResources.get('ok'),
						handler: this._resetPassword.bind(this),
						type: 'primary',
						defaultId: 'updatePassword'
					}, 'cancel'],
					title: StringResources.get('changePasswordTitle'),
					viewOptions: {
						glassContext: this.Glass
					}
				};
				SubmitPasswordDialog.prototype.openSubmitPasswordDialog(dialogOptions).then((passwordDialogObj) => {
					this._passwordDialogObj = passwordDialogObj;
					resolve();
				}, reject);
			});
		}

		_resetPassword() {
			const oldPW = $(`input[class*="${this._passwordDialogObj.oldPasswordName}"]`).val();
			const newPW = $(`input[class*="${this._passwordDialogObj.newPasswordName}"]`).val();
			const options = {
				type: 'PUT',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				url: `${ADMIN_ACCOUNT_URL}${this.Glass.getCoreSvc('.UserProfile').preferences.id}`,
				data: JSON.stringify({
					password: newPW,
					oldPassword: oldPW
				})
			};

			return this.Glass.getCoreSvc('.Ajax').ajax(options).then(response => {
				if (response.errorCode === 1) {
					// Request failed with incorrect old password.
					this.Glass.showToast(StringResources.get('wrongPassword'), { type: 'error' });
				} else {
					this.Glass.showToast(StringResources.get('passWordChangeSuccess'));
					this._passwordDialogObj.dialog.hide();
				}
			}).catch(err => {
				this.Glass.showToast(StringResources.get('updatePWUnknownError'), { type: 'error' });
				console.error(err);
				this._passwordDialogObj.dialog.hide();
			});
		}

		_buildParameters(displayObjects) {
			this.credentialParameters = [];
			const displayParameters = [];
			$.each(displayObjects, (key, prompt) => {
				this.credentialParameters.push(prompt);
				if ('hidden' !== prompt.type && 'display' !== prompt.type) {
					displayParameters.push(prompt);
				}
			});
			return displayParameters;
		}
	}

	return CredentialDialogs;
});